import { render, staticRenderFns } from "./CameraAcessModal.vue?vue&type=template&id=1489b05a"
import script from "./CameraAcessModal.vue?vue&type=script&lang=js"
export * from "./CameraAcessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports